import React from 'react';
import { Input } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class FontEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <Input value={this.props.source.value} onChange={e => this.onChange(e)} placeholder={this.props.source.placeholder} />
        );
    }
}

PropertyGridUtils.register("font", (source, propertyGrid) => <FontEditor source={source} propertyGrid={propertyGrid} />);